import { LANGUAGE } from '@src/constants';

const pluralize = (count, word, language) => {
  if (language === LANGUAGE.VN) {
    return word;
  }

  let result = word;
  if (count < 2 || !count) {
    return word;
  }

  if (word.endsWith('y') && !/[aeiou]y$/.test(word)) {
    // city -> cities
    result = `${word.slice(0, -1)}ies`;
  } else if (
    word.endsWith('s') ||
    word.endsWith('sh') ||
    word.endsWith('ch') ||
    word.endsWith('x') ||
    word.endsWith('z')
  ) {
    // bus -> buses, box -> boxes
    result = `${word}es`;
  } else {
    // mặc định thêm s
    result = `${word}s`;
  }
  return result;
};

export default pluralize;
